import { WeekStatus } from '../components/WeekStatus'
import { Actions } from '@components/shared/Actions'
import { EyeIcon } from '@assets/svgs/EyeIcon'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { ClientProps } from '../context/types'

interface ParseClientsProps {
  data?: ClientProps[]
  onEdit: (data: ClientProps) => void
}

export const parseClientsGrid = ({ data, onEdit }: ParseClientsProps) => {
  if (!data) return []

  const parsedData: ColumnDefProps[][] = data.map((item) => [
    {
      id: 'clientName',
      columnName: 'Nome do cliente',
      value: `${Math.floor(Number(item.cdClienteNl))} - ${item.desClienteNl}`,
      minWidth: '14rem',
      sortable: true,
      headerAlign: 'center',
      bodyAlign: 'left'
    },
    {
      id: 'clientType',
      columnName: 'Tipo de cliente',
      value: item.tipoCliente,
      minWidth: '9rem',
      sortable: true,
      headerAlign: 'center',
      bodyAlign: 'left'
    },
    {
      id: 'grossRevenue',
      columnName: 'Faturamento Bruto (R$)',
      align: 'center',
      currency: true,
      value: item.faturamentoBruto,
      sortable: true,
      headerAlign: 'center',
      bodyAlign: 'right'
    },
    {
      id: 'netRevenue',
      columnName: 'Faturamento Líquido (R$)',
      align: 'center',
      currency: true,
      value: item.faturamentoLiquido,
      sortable: true,
      headerAlign: 'center',
      bodyAlign: 'right'
    },
    {
      id: 'weekStatus',
      columnName: 'Status do Cliente',
      align: 'center',
      value: <WeekStatus status={item.hasCompleteDistribution ? 'completed' : 'pending'} />,
      withoutTooltip: true
    },
    {
      id: 'actions',
      columnName: 'Ações',
      align: 'center',
      minWidth: '5rem',
      maxWidth: '5rem',
      stickyPosition: 'right',
      withoutTooltip: true,
      value: <Actions actions={[{ label: 'Visualizar', icon: <EyeIcon />, onClick: () => onEdit(item) }]} />
    }
  ])

  return parsedData
}
